'use client';
import { deleteThreadFromSidebarEvent } from '#pplx/frontend/apps/ask/events/thread/analytics.js';
import { useThreadMutations } from '#pplx/frontend/apps/ask/hooks/threads-hooks/useThreadMutations.js';
import { threadLinkMatchesPath } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/threadLinkMatchesPath.js';
import { routes } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useCallback, useState } from 'react';
export function useSidebarThreadDeletion() {
    const pathname = usePathname();
    const router = useRouter();
    const { track } = useInstrumentation();
    const { deleteThread } = useThreadMutations({ reason: 'sidebar-v3' });
    const [deleted, setDeleted] = useState(new Set());
    const handleDeleteThreadClick = useCallback((item) => {
        track(deleteThreadFromSidebarEvent({
            name: 'delete thread from sidebar',
            data: {
                entryUUID: item.uuid,
            },
        }));
        setDeleted((prev) => new Set([...prev, item.uuid]));
        deleteThread({
            entryUUID: item.uuid,
            callback: () => {
                if (pathname && threadLinkMatchesPath(item.link, pathname)) {
                    router.push(routes['/'].href());
                }
            },
        });
    }, [deleteThread, pathname, router, track]);
    return { deleted, handleDeleteThreadClick };
}
//# sourceMappingURL=useSidebarThreadDeletion.js.map